import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FiBriefcase, FiCreditCard, FiPackage, FiUsers, FiArrowLeft } from 'react-icons/fi';

const PanipuravthaTransactions = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { grampanchayatName, arthikVarshLabel } = location.state || {};

  const menuItems = [
    {
      id: 'other-transactions',
      title: 'इतर व्यवहार',
      icon: <FiBriefcase className="w-8 h-8" />,
      description: 'इतर दैनंदिन व्यवहार',
      path: '/panipuravtha/transactions/other',
      color: 'from-blue-500 to-cyan-500'
    },
    {
      id: 'loan-deposit',
      title: 'कर्ज व अनामत',
      icon: <FiCreditCard className="w-8 h-8" />,
      description: 'कर्ज आणि अनामत माहिती',
      path: '/panipuravtha/transactions/loan-deposit',
      color: 'from-emerald-500 to-teal-500'
    },
    {
      id: 'stock-deadstock',
      title: 'साठा व डेडस्टॉक',
      icon: <FiPackage className="w-8 h-8" />,
      description: 'संग्रहित साठा व डेडस्टॉक',
      path: '/panipuravtha/transactions/stock-deadstock', // Updated path
      color: 'from-orange-500 to-amber-500'
    },
    {
      id: 'salary-info',
      title: 'पगार माहिती',
      icon: <FiUsers className="w-8 h-8" />,
      description: 'कर्मचारी पगार माहिती',
      path: '/panipuravtha/transactions/salary-info', // Updated path to new component
      color: 'from-purple-500 to-indigo-500'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50 p-6 md:p-8 font-poppins">
      {/* Header */}
      <div className="max-w-7xl mx-auto mb-10">
        <div className="bg-white rounded-2xl shadow-lg p-6 md:p-8 flex flex-col md:flex-row justify-between items-center bg-gradient-to-r from-slate-800 to-slate-900 text-white">
          <div className="flex items-center gap-4">
             <button 
                onClick={() => navigate(-1)} 
                className="hover:bg-white/10 p-2 rounded-full transition-colors flex items-center justify-center"
            >
                <FiArrowLeft className="text-2xl" />
            </button>
            <div>
                <h1 className="text-3xl font-bold mb-2">पाणीपुरवठा - व्यवहार</h1>
                <p className="text-slate-300">
                {grampanchayatName ? `${grampanchayatName} | ` : ''}आर्थिक वर्ष: {arthikVarshLabel || '२०२४-२५'}
                </p>
            </div>
          </div>
        </div>
      </div>

      {/* Menu Grid */}
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {menuItems.map((item) => (
          <div 
            key={item.id}
            onClick={() => item.path !== '#' && navigate(item.path, { state: location.state })}
            className="group cursor-pointer bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 overflow-hidden border border-gray-100"
          >
            <div className={`h-2 bg-gradient-to-r ${item.color}`}></div>
            <div className="p-6 text-center flex flex-col items-center">
              <div className={`w-16 h-16 rounded-xl bg-gradient-to-br ${item.color} flex items-center justify-center text-white mb-4 shadow-lg group-hover:scale-110 transition-transform duration-300`}>
                {item.icon}
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-2 group-hover:text-blue-600 transition-colors">
                {item.title}
              </h3>
              <p className="text-gray-500 text-sm">
                {item.description}
              </p>
            </div>
            <div className="px-6 py-4 bg-gray-50 border-t border-gray-100 flex justify-between items-center">
              <span className="text-sm font-medium text-gray-600 group-hover:text-blue-600 transition-colors">
                निवडा
              </span>
              <svg 
                className="w-5 h-5 text-gray-400 group-hover:text-blue-600 transform group-hover:translate-x-1 transition-all duration-300" 
                fill="none" 
                viewBox="0 0 24 24" 
                stroke="currentColor"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PanipuravthaTransactions;
